import { Route, Routes } from 'react-router-dom';
import { ROLE } from '../../../Constant';
import { PrivateRoute } from '../../components/PrivateRoute';
import License from './ban-quyen';

import TenantCompany from './thong-tin-doanh-nghiep';

export default function DoanhNghiep() {

  return (
    <Routes>
      {/* <Route path="thong-tin-doanh-nghiep/*" element={<PrivateRoute role={ROLE.COMPANY_MANAGEMENT_INFO}> <TenantCompany/></PrivateRoute>}/> */}
      <Route path="thong-tin-doanh-nghiep/*" element={<TenantCompany />} />

      {/* <Route path="ban-quyen/*" element={<PrivateRoute role={ROLE.COMPANY_MANAGEMENT_LICENSE}> <License /></PrivateRoute>} /> */}
      <Route path="ban-quyen/*" element={<License />} />

    </Routes>
  );
}
